import React, { useState} from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';

import { ReactComponent as DownArrowSvg } from '../assets/down-arrow.svg';
import { BodySmall, LabelSmall } from './typography';

export default function ZoneSelector ({ activeZoneProp, dispatch, state, sx }) {
  const {
    currentScreen,
    SCREENS,
    selectedHome,
    vtCurrentRoomName,
    vtCurrentZoneName,
    vtSceneData,
  } = state;

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = !!anchorEl;
  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const isHome2D = (currentScreen === SCREENS.HOME_2D);
  let activeZone = '';
  if (isHome2D) {
    activeZone = selectedHome?.exteriorImages?.[0]?.name || '';
  } else {
    activeZone = vtCurrentRoomName || vtCurrentZoneName || 'Virtual Tour';
  }

  const handleMenuItemClicked = (data) => {
    if (data?.room && data?.room?.name !== vtCurrentRoomName) {
      dispatch({ type: 'zone-selector-room-menu-item-clicked', payload: data });
    } else if (data?.zone && data?.zone?.name !== vtCurrentZoneName) {
      dispatch({ type: 'zone-selector-zone-menu-item-clicked', payload: data });
    } else if (data?.image && data?.image?.name !== activeZone) {
      dispatch({ type: 'zone-selector-image-item-clicked', payload: data });
    }
    handleMenuClose();
  };
  
  const menuItems = renderMenuItems({
    isHome2D,
    onClick: handleMenuItemClicked,
    selectedHome,
    vtSceneData
  });

  const menuItemsCnt = menuItems.length;
  const disableMenu = menuItemsCnt < 2;

  return (
    <div>
      <Button
        id='zone-selector'
        aria-controls={isOpen ? 'vt-zones-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        disabled={disableMenu}
        onClick={handleButtonClick}
        endIcon={menuItemsCnt > 1 ? <DownArrowSvg /> : undefined}
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '50px',
          color: '#000000',
          fontFamily: 'MabryPro',
          fontSize: '0.875rem',
          fontWeight: 500,
          justifyContent: 'space-between',
          px: 2.5,
          textTransform: 'none',
          height: '3.25rem',
          width: '13rem',
          '&:hover': {
            backgroundColor: '#E0E0E0',
          },
          '&:disabled': {
            backgroundColor: '#FFFFFF',
            color: '#000000',
          },
          ...sx,
        }}
        variant="contained"
      >
        {activeZone}
      </Button>
      <Menu
          id='zone-selector'
          aria-labelledby='vt-zones-menu'
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          PaperProps={{
            sx: {        
              borderRadius: '27px',      
              pl: 1.75,
              pt: 1.25,
              transform: 'translateY(-1rem) !important',
              width: '13rem',
            },
          }}
        >
          {menuItems}
      </Menu>
    </div>
  );
}

function renderMenuItems ({ isHome2D, onClick, selectedHome, vtSceneData }) {
  let menuItems = [];

  if (isHome2D) {
    const image = selectedHome?.exteriorImages?.[0];
    const name = image?.name || '';
    menuItems.push(
      <MenuItem key={name} name={name} onClick={() => onClick({ image })} mt={0} />
    );
  } else {
    vtSceneData?.forEach?.((zone, index) => {
      const isFirstZone = index === 0;
      const { isExterior, name, rooms } = zone;
      if (isExterior) {
        menuItems.push(
          <MenuLabel key='exterior' name='Exterior' mt={isFirstZone ? 0 : 3} />
        );

        menuItems.push(
          <MenuItem key={name} name={name} onClick={() => onClick({ zone })} mt={0} />
        );
      } else if (rooms?.length > 0) {
        menuItems.push(
          <MenuLabel key={name} name={name} mt={isFirstZone ? 0 : 3} />
        );

        rooms.forEach(room => {
          menuItems.push(
            <MenuItem key={room.name} name={room.name} onClick={() => onClick({ room })} mt={0} />
          );
        });
      } else {
        menuItems.push(
          <MenuItem key={name} name={name} onClick={() => onClick({ zone })} mt={isFirstZone ? 0 : 3} />
        );
      }
    });
  }

  if (menuItems.length === 0) {
    const name = 'Virtual Tour';
    menuItems.push(
      <MenuItem key={name} name={name} mt={0} />
    );
  }

  return menuItems;
}

function MenuItem ({ name, onClick, mt }) {
  return (
    <MuiMenuItem
      onClick={onClick}
      sx={{
        pb: 1.25,
        mt,
      }}
    >
      <BodySmall
        sx={{
          color: '#2D2D2D',
          fontSize: '0.875rem',
        }}
      >
        {name}
      </BodySmall>
    </MuiMenuItem>
  );
}

function MenuLabel ({ name, onClick, mt }) {
  return (
    <LabelSmall
      onClick={onClick}
      sx={{
        fontWeight: 500,
        pb: 1.5,
        pl: 2,
        pt: 0.75,
        mt,
      }}
    >
      {name}
    </LabelSmall>
  );
}
